export const BUSCADOR = {
    SearchCustomer: 'Services/General/CustomerService.svc/GetAll',
    GetByCustomerCodeWithContacts: 'Services/General/CustomerService.svc/GetByCustomerCodeWithContacts',
    GetByCustomerCode: 'Services/Workshop/VehicleService.svc/GetByCustomerCode',
    GetCustomerNotifications: 'Services/General/CustomerService.svc/GetCustomerNotifications',


    SearchVehicle: 'Services/Workshop/VehicleService.svc/GetAll',
    GetByChassisWithCarCodes: 'Services/Workshop/VehicleService.svc/GetByChassisWithCarCodes',
    GetAllMarcasVehiculos: 'Services/Workshop/VehicleBrandService.svc/GetAllVehicleBrands',
    GetAllModelosTallerCitroen: 'Services/Workshop/VehicleModelService.svc/GetAllModels',
    GetAllGaranteeExtensions: 'Services/Workshop/GaranteeExtensionsService.svc/GetAll',
    GetProductionOrderHistory: 'Services/Workshop/VehicleService.svc/GetProductionOrderHistory',
    CarHistorySearch: 'Services/Workshop/VehicleService.svc/CarHistorySearch',
    GetVehicleHistoryEsa: 'Services/Workshop/EsaService.svc/GetVehicleHistory',

    BrandMaterialGetAll: 'Services/WareHouse/BrandMaterialService.svc/GetAll',
    FindMaterialsPaged: 'Services/WareHouse/WareHouseMaterialService.svc/GetAll',
    GetByMaterialCodeWithDetails: 'Services/WareHouse/WareHouseMaterialService.svc/GetByMaterialCodeWithDetails',
    GetAllSuppliers: 'Services/General/CustomerService.svc/GetAllSuppliers',
    VatTypeServiceGetAll: 'Services/General/VatTypeService.svc/GetAll',
    ComboCodigoContable: 'Services/WareHouse/AccountingCodesService.svc/GetAll',
    EcoTaxesGetAll: 'Services/WareHouse/EcoTaxesService.svc/GetAll',
    MaterialIndexesGetAll: 'Services/WareHouse/MaterialIndexesService.svc/GetAll',
    SearchSegment: 'Services/WareHouse/MaterialSegmentsService.svc/GetByIndexCode',
    SearchCrenau: 'Services/WareHouse/CrenauCodeService.svc/GetBySegmentCode',
    SearchFamily: 'Services/WareHouse/MarketingFamiliesService.svc/GetByCrenauCode',
    GetWareHouseMovementsByCode: 'Services/WareHouse/WareHousesService.svc/GetWareHouseMovementsByCode',
};

